import configAxios, {updateToken} from "../configuration/configAxios";
import {configCookies, setCookie} from "../configuration/cookiesConfig";
import {useMutation, UseMutationResult} from "@tanstack/react-query";
import {ID_TOKEN} from "../../conf";
import Cookies from "js-cookie";
import {errorHandlerServices} from "../configuration/errorHandle";
import {UserInterface} from "../interface/UserInterface";

interface LoginProps {
    username: string,
    password: string
}

export const getTokenRegistration = async (data: LoginProps) => {
    return await configAxios.post(`/auth/realms/pagina-web-ricaurte/protocol/openid-connect/token`,
        `username=${data.username}&password=${data.password}&client_id=front-pagina-ricaurte&grant_type=password`,
        {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        }).then(response => {
        const token = response.data.access_token;
        setCookie(ID_TOKEN, token)
        updateToken(`${token}`);
        return response.data
    }).catch(error => {
        errorHandlerServices(error, false)
        throw new Error(error?.response?.data?.message ? error?.response?.data?.message : `Error service: /api/users/create`);
    })
}

export const useCredentials = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: LoginProps) => getTokenRegistration(data),
    });
}

export function logoutSession(){
    Cookies.remove(ID_TOKEN, configCookies);
    window.location.reload();
}

export const decodeIdToken = (token: string | undefined): any => {
    if (token) {
        try {
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(atob(base64).split('').map((c) => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`).join(''));

            return JSON.parse(jsonPayload);
        } catch (e) {
            return null
        }
    } else {
        return null
    }
};

export const findUserById = async (data: UserInterface) => {
    return await configAxios.get(`/ms-menus/usuario/getById-usuario`, {
        params: {
            idUsuario: data.username
        }
    }).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return response.data.object
        }
    }).catch(error => {
        errorHandlerServices(error, true)
        throw new Error(error?.response?.data?.message ? error?.response?.data?.message : `Error service: /ms-menus/process/findUserById`);
    })
}

export const useFindById = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: UserInterface) => findUserById(data),
    });
}
